export default __webpack_public_path__ + "assets/images/359efabed7ed4f2f2035cd32f329da57.svg";